import { useMediaQuery } from 'react-responsive';

const InputSpacer = () => {
  const isMobile = useMediaQuery({
    query: '(max-width: 768px)',
  });

  return <div style={{ height: isMobile ? 0 : 20 }} />;
};

export default InputSpacer;
